module.exports = __webpack_public_path__ + "img/magnifier.4cdace49.png";